import { FC, ReactNode } from 'react'
import { MODAL_VARIANTS } from '../../../providers/BookingCalendar/types'
import { Box, Typography, SxProps } from '@hermes/web-components'
import { StyledDialog } from '../../profiles/ProfileModal/ProfileModalLayout'
import Header from '../../Header'
import { FullScreenDialog, StyledCloseIcon, StyledContainer } from './styles'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import { useWpaTenant } from '../../../hooks/useWpaTenant'
import ProviderHeader from '../../ProviderHeader'
import { PROVIDERS_VARIANTS } from '../../ClaimYourProfile/types'

interface DialogBaseProps {
  sx?: SxProps
  children: ReactNode
  variant: MODAL_VARIANTS
  open: boolean
  onReturnBackClick?: () => void
  onClose?: () => void
}

interface CloseSectionProps {
  sx?: SxProps
  onReturnBackClick?: () => void
  onClose?: () => void
}

const CloseSection: FC<CloseSectionProps> = ({ sx, onReturnBackClick, onClose }) => {
  const translate = useTranslateMessage()
  return (
    <Box
      sx={{
        position: onReturnBackClick ? 'initial' : 'absolute',
        right: '32px',
        top: '20px',
        zIndex: 1,
        ...(sx || {})
      }}
    >
      {onReturnBackClick ? (
        <Box
          display="flex"
          position="relative"
          justifyContent="space-between"
          alignItems="center"
          p="20px 20px 10px 20px"
        >
          <Typography
            color="#3C4659"
            onClick={onReturnBackClick}
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            {translate('back')}
          </Typography>
          <StyledCloseIcon onClick={onClose} />
        </Box>
      ) : (
        <StyledCloseIcon onClick={onClose} />
      )}
    </Box>
  )
}

const DialogBase: FC<DialogBaseProps> = ({ children, variant, onReturnBackClick, ...props }) => {
  const { isWPA } = useWpaTenant()

  if (variant === MODAL_VARIANTS.FULL_SCREEN) {
    return (
      <FullScreenDialog fullScreen {...props}>
        <CloseSection
          sx={{ display: { xs: 'flex', sm: 'none' } }}
          onReturnBackClick={onReturnBackClick}
          onClose={props.onClose}
        />
        {isWPA ? (
          <ProviderHeader variant={PROVIDERS_VARIANTS.WPA} shouldReverse logoAlign="flex-end" />
        ) : (
          <Header sx={{ display: { xs: 'none', sm: 'flex' } }} />
        )}
        <StyledContainer>
          <Box width="100%" maxWidth="1040px">
            {children}
          </Box>
        </StyledContainer>
      </FullScreenDialog>
    )
  }

  if (variant === MODAL_VARIANTS.SIDE_MODAL) {
    return (
      <StyledDialog {...props}>
        <CloseSection onReturnBackClick={onReturnBackClick} onClose={props.onClose} />
        <Box height={onReturnBackClick ? 'calc(100% - 65px)' : '100%'} display="flex">
          {children}
        </Box>
      </StyledDialog>
    )
  }

  return null
}

export default DialogBase
